<template>
    <div class="col-12 content mb-20 mb-lg-0 text-center" v-if="! is_data_ready">
        <span class="loader"></span>
    </div>

    <div class="col-12 content mb-20 mb-lg-0 text-center" v-else-if="!player">
        <p>No detail data found.</p>
    </div>
    <div class="content mb-20 mb-lg-0" v-else>

        <div class="widget-box">
            <div class="widget-box-head">
                <strong class="h2">info</strong>
            </div>
            <ul class="info-wrp-ul">
                <li v-if="player.firstname">
                    <span class="title">First Name</span>
                    <span class="sub-title"><span class="text">{{player.firstname = player.firstname.charAt(0).toUpperCase() + player.firstname.slice(1)}}</span></span>
                </li>
                <li v-if="player.lastname">
                    <span class="title">Last Name</span>
                    <span class="sub-title"><span class="text">{{player.lastname = player.lastname.charAt(0).toUpperCase() + player.lastname.slice(1)}}</span></span>
                </li>
                <li v-if="player.nick">
                    <span class="title">Nick Name</span>
                    <span class="sub-title"><span class="text">{{player.nick = player.nick.charAt(0).toUpperCase() + player.nick.slice(1)}}</span></span>
                </li>
                <li v-if="player.weight">
                    <span class="title">Weight</span>
                    <span class="sub-title"><span class="text">{{player.weight}}</span></span>
                </li>
                <li v-if="player.height">
                    <span class="title">Height</span>
                    <span class="sub-title"><span class="text">{{player.height}} ft'</span></span>
                </li>
                <li v-if="player.education">
                    <span class="title">Education</span>
                    <span class="sub-title"><span class="text">{{player.education = player.education.charAt(0).toUpperCase() + player.education.slice(1)}}</span></span>
                </li>

                <li v-if="player.birth_place">
                    <span class="title">BirthPlace</span>
                    <span class="sub-title"><span class="text">{{player.birth_place = player.birth_place.charAt(0).toUpperCase() + player.birth_place.slice(1)}}</span></span>
                </li>
            </ul>
        </div>

        <div class="widget-box">
            <div class="widget-box-head">
                <strong class="h2">Teams</strong>
            </div>
            <ul class="countary-team-list">
                <li v-for="item in player.PlayerTeams" :key="item"  v-if="item.team.id">
                <router-link :to="{ name: 'TeamDetails.Players', params:  {  team: item.team.slug} }">
                    <span class="icon-flag"><img :src="'https://cric.livescoring.cc/teamflags/'+ item.team.id +'.png'" alt=""></span>
                    <strong class="name">{{item.team.name}}</strong>
                </router-link>

                </li>

            </ul>
        </div>

    </div>

</template>

<script>
    import Vue from 'vue'
    import moment from 'moment'
    export default {
        name: 'info',

        data() {
            return {
                player: [],
                age: ''
            }
        },

        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return

                let teams = []
                this.player.PlayerTeams.forEach((element) => {
                teams.push(
                    {
                        "@type": "SportsTeam",
                        "name": element.team.name,
                        logo: element.team.flag,
                        "url" : process.env.BASE_URL
                    }
                )
            });
                return {   
                "@context": "http://schema.org",
                "@graph": teams
            }
        },

        metaInfo() {

            if (!this.player)
                return

            let title = this.player.full_name + " Info" + " - PlanetCricket.com";
            let description = this.player.full_name + "- Info" + " - PlanetCricket.com";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },

        methods: {
            main() {

                return this.$axios
                        .get(this.$PLAYER_DETAIL_API.replace(':player', this.$route.params.player))
                        .then(response => {
                            this.is_data_ready = true
                            this.player = response.data.result || []
                            this.ageCalculate(this.player.dob)
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
            ageCalculate(DOB) {
                var date = new Date().toISOString().slice(0, 10);
                var datee = moment(date).format('YYYY-MM-DD');
                if (DOB < datee)
                {
                    return  this.age = Vue.filter('age')(DOB);
                } else
                {
                    return this.age = '';
                }


            }
        }
    }
</script>